import { observer } from 'mobx-react';
import * as React from 'react';
import Participants from './Participants';
import Groups from './Groups';
import { findLink } from '../../../LinkyLinky';
import { currentUserStore } from '../../../CurrentUserStore';
import { emptyFragment } from '../../../EmptyFragment';

// TODO: add segments and administrators in future stories
const Nav: React.FC = () => (
  <div className="flex">
    <Participants />
    {findLink('user-groups', currentUserStore.links)
      .map(() => <Groups />)
      .getOrElse(emptyFragment)}
  </div>
);

export default observer(Nav);
